<template>
  <div id="app">
    <MainNav/>

    <router-view/>

    <div id="footer">

      <section class="uk-container uk-margin-xlarge-bottom">
        <h2>Jason de Ridder / Voice over & stemacteur</h2>
        <div class="
          uk-flex
          uk-flex-around
          uk-flex-wrap
          uk-flex-wrap-middle
          footer
        ">
          <a href="https://jasonderidder.nl" target="_blank" class="uk-navbar-item uk-width-auto@s">
            Acteur
          </a>
          <router-link to="/tarieven" class="uk-navbar-item uk-width-auto@s">
            Tarieven
          </router-link>
          <router-link to="/voice-over-aanvragen" class="uk-navbar-item uk-width-auto@s">
            Voice Over Aanvragen
          </router-link>
          <router-link to="/tevredenheid" class="uk-navbar-item uk-width-auto@s">
            Tevredenheid
          </router-link>
          <router-link to="/veelgestelde-vragen" class="uk-navbar-item uk-width-auto@s">
            Veelgestelde vragen
          </router-link>
          <router-link to="/contact" class="uk-navbar-item uk-width-auto@s">
            Contact
          </router-link>
        </div>
        <div class="
          uk-flex
          uk-flex-center
          uk-flex-wrap
          uk-flex-wrap-middle
          footer
        ">
          <a href="https://instagram.com/JasonDeRid" target="_blank"
             class="uk-padding-small">
            <img :src="require('@/assets/images/icons/instagram.svg')"
                 alt="Instagram"
                 style="width: 30px;"
                 uk-svg
            />
          </a>
          <a href="https://www.imdb.com/name/nm5014152" target="_blank"
            class="uk-padding-small">
            <img :src="require('@/assets/images/icons/imdb.svg')"
                 alt="IMDb"
                 style="width: 30px;"
                 uk-svg
            />
          </a>
          <a href="https://vimeo.com/jasonderidder/showreel" target="_blank"
            class="uk-padding-small">
            <img :src="require('@/assets/images/icons/vimeo.svg')"
                 alt="Vimeo"
                 style="width: 30px;"
                 uk-svg
            />
          </a>
        </div>

      </section>

    </div>
  </div>
</template>

<script>
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import Audio from '@/audio-bus';
import MainNav from '@/components/MainNav.vue';

const { AudioBus } = Audio;

UIkit.use(Icons);
UIkit.navbar('#nav', {});
UIkit.sticky('#sticky-nav', {});

export default {
  name: 'App.vue',
  components: {
    MainNav,
  },
  computed: {
    icon: () => (AudioBus.playing ? 'icon: file; ratio: 1.1' : 'icon: play; ratio: 1.1'),
  },
  data() {
    return {
      playing: false,
    };
  },
};
</script>

<style lang="scss">
  // Own variables
  @import 'assets/theme/variables';

  // UIKit variables
  @import '~uikit/src/scss/variables-theme';
  @import '~uikit/src/scss/mixins-theme';

  // Override mixins
  @import 'assets/theme/mixins';

  // Putting it together
  @import '~uikit/src/scss/uikit-theme';

  // Other external resources
  @import '~hamburgers/_sass/hamburgers/hamburgers';

  @import 'assets/theme/styles';

  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

</style>
